import Modal from "../../../global/components/Modal/Modal.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

// @vue/component
export default {
  name: "CodeModalAusfuehren",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    obj: {
      type: Object,
      default: () => ({}),
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      modalOptions: {
        showCloseButton: true,
      },
      status: {
        loading: undefined,
      },
      error: undefined
    };
  },
  computed: {
    translationMsgSuccess() {
      return {
        text: "_MSG_CODE_TABLE_MODAL_EXECUTE_SUCCESS_{{code}}_",
        extra: { code: this.obj.co_code }
      };
    },
  },
  methods: {
    executeCode() {
      this.status.loading = true;
      this.error = undefined;
      this.postHttp({ url: `codes/${ this.obj.pk }/ausfuehren/` }).then(
        response => {
          this.addNotification(this.translationMsgSuccess);
          this.close({ response });
        },
        error => {
          this.error = error.data;
          // eslint-disable-next-line vue/no-mutating-props
          this.obj.co_ausgefuehrt_error = this.error;
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
